/** @jsxImportSource @emotion/react */

import tw from "twin.macro";
import { FieldProps } from "./Field.d";

const Field: React.FC<FieldProps> = ({ label, text, wrapperCss }) => {
  return (
    <>
      <div css={[tw`flex flex-col items-start gap-1.5`, wrapperCss]}>
        <div css={[tw`font-medium text-sm text-gray-400`]}>{label}</div>
        <div
          css={
            text
              ? [tw`text-base text-gray-900`]
              : [tw`bg-gray-100 w-1/2 p-2 rounded-md`]
          }
        >
          {text}
        </div>
      </div>
    </>
  );
};

export default Field;
